import React from 'react'
import Step1 from './Step1'
import Step2 from './Step2'
import Step3 from './Step3'
import StepNavigationHeader from '../../StepNavigationHeader'
import Very from '../../../helpers/request_wrapper'
import Loader from '../../Loader'
import { Provider } from 'react-redux'
import store from '../../store';

class Index extends React.Component {
  constructor(props) {
    super(props);
    this.mediaPlanObj = {};
    this.state = { currentStep: 1 };
  }

  handleClick = (value) => {
    this.setState({ currentStep: value })
  };

  handleSubmit = (data) => {
    this.mediaPlanObj = {...this.mediaPlanObj, ...data};

    if (this.state.currentStep === 3) {
      const { persona } = this.props ;
      Very.post(`/media_plans`, { media_plan: this.mediaPlanObj, persona_id: persona ? persona.id : null }).then(res => {
        let media_plan_id = res.data.id;
        window.location.replace(`/media_plans/${media_plan_id}`)
      })
    }

    this.setState({ currentStep: this.state.currentStep + 1 })
  };

  render() {
    const { currentStep } = this.state;
    const { persona } = this.props;
    const menu = [
      'Budget',
      'Territory',
      'Channels'
    ];

    return (
        <Provider store={store}>
          <StepNavigationHeader
            cancelUrl="/media_plans"
            currentStep={currentStep}
            handleClick={this.handleClick}
            menu={menu}
          />

          <div className="col-12 py-110 sm-py4">
            <div className="center md-px3 mx-auto" style={{ maxWidth: '1110px' }}>
                {
                  currentStep === 1 &&
                  <Step1
                    data={this.mediaPlanObj}
                    submit={this.handleSubmit}
                  />
                  || currentStep === 2 &&
                  <Step2
                    data={this.mediaPlanObj}
                    submit={this.handleSubmit}
                    countriesList={this.props.countries}
                    countries={persona ? persona.audience.country : ''}
                  />
                  || currentStep === 3 &&
                  <Step3
                    data={this.mediaPlanObj}
                    submit={this.handleSubmit}
                    insights={persona.social_media_insight}
                  />
                  || currentStep === 4 && <Loader />
                }
            </div>
          </div>
        </Provider>
    );
  }
}

export default Index
